<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M42 4H6a2 2 0 00-2 2v6a2 2 0 002 2h36a2 2 0 002-2V6a2 2 0 00-2-2zm-1 7H7V7h34zM42 19H6a2 2 0 00-2 2v6a2 2 0 002 2h36a2 2 0 002-2v-6a2 2 0 00-2-2zm-1 7H7v-4h34zM42 34H6a2 2 0 00-2 2v6a2 2 0 002 2h36a2 2 0 002-2v-6a2 2 0 00-2-2zm-1 7H7v-4h34z"/></svg>